<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>Completed Jobs Report</h2>
    </div>
    <div class="ibox-content report-box" style="min-height: 125px">
      <div class="row">
        <div class="col-xs-12">
          <div class="m-b-md">
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="all_time"
                name="completed_jobs_period"
                id="completed_jobs_period_all_time">

              <label for="completed_jobs_period_all_time">All Time</label>
            </div>
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="date_range"
                name="completed_jobs_period"
                id="completed_jobs_period_range">
              <label for="completed_jobs_period_range">Date Range</label>
            </div>
          </div>

          <div class="form-group" v-show="periodSelectedIsDateRange">
            <date-range
              v-model="dateRange"
              :max-date="yesterday"
              name="date_range">
            </date-range>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-footer text-right">
      <ladda-button
        :on-click="handleGenerateReport"
        class="btn btn-primary btn-sm">
        <i class="fa fa-cloud-download fa-fw"></i> Download XLS
      </ladda-button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateRange, Selectize, LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import moment from 'moment'

  export default {
    components: {
      DateRange,
      Selectize,
      LaddaButton
    },

    data () {
      return {
        period: 'all_time',
        dateRange: {
          from: null,
          to: null
        }
      }
    },

    watch: {
      period () {
        if (this.period === 'all_time') {
          this.dateRange = {
            from: null,
            to: null
          }
        } else {
          this.dateRange = {
            from: moment().startOf('month').format('DD/MM/YYYY'),
            to: moment().subtract(1, 'day').format('DD/MM/YYYY')
          }
        }
      }
    },

    computed: {
      yesterday () {
        return moment().subtract(1, 'day')
      },

      periodSelectedIsDateRange () {
        return this.period === 'date_range'
      },

      generatePayload () {
        return {
          from: this.dateRange.from ? this.dateRange.from : null,
          to: this.dateRange.to ? this.dateRange.to : null
        }
      }
    },

    methods: {
      ...mapActions('report', ['generateCompletedJobsReport']),

      handleGenerateReport () {
        return this.validateAll().then(response => {
          const listenForReportGenerated = () => {
            notify.success('Please wait while we get your download ready.')
          }

          return this.generateCompletedJobsReport(this.generatePayload).then(listenForReportGenerated)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CompletedJobsReport.vue?16a851ef